import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  formSubmitted: false,
  otpValidated: false,
  smsSessionId: '',
  recaptchaToken: '',
  formHash: '',
  selectedVolumeTier: '',
};

const signupSlice = createSlice({
  name: 'signup',
  initialState,
  reducers: {
    setFormSubmitted: (state) => {
      state.formSubmitted = true;
    },
    setOtpValidated: (state, isValid) => {
      state.otpValidated = isValid;
    },
    setSmsSessionId: (state, sessionId) => {
      state.smsSessionId = sessionId;
    },
    setRecaptchaToken: (state, { payload: { token } }) => {
      state.recaptchaToken = token;
    },
    setFormHash: (state, hash) => {
      state.formHash = hash;
    },
    setSelectedVolumeTier: (state, tier) => {
      state.selectedVolumeTier = tier;
    },
  }
});

export const { setFormSubmitted } = signupSlice.actions;
export const { setOtpValidated } = signupSlice.actions;
export const { setRecaptchaToken } = signupSlice.actions;
export const { setSmsSessionId } = signupSlice.actions;
export const { setFormHash } = signupSlice.actions;
export const { setSelectedVolumeTier } = signupSlice.actions;

export default signupSlice.reducer;
